import { makeAutoObservable } from "mobx";
import { BreadcrumbItem } from "src/appStore";
import {
  loadObjectAccess,
  saveObjectAccess,
} from "src/business/access/apiAccess";
import { ZObjectAccess } from "src/business/access/ZObjectAccess";
import { ZSpecAccess } from "src/business/access/ZSpecAccess";
import { loadClassifier, ZClassifier } from "src/business/classifier";
import { SpecificationsAccessStore } from "src/business/specification/SpecificationsAccessEditor";
import { RemoteData } from "src/common/RemoteData";
import { PageUrl } from "src/routes/PageUrl";

export type ClassifierAccessData = {
  classifier: ZClassifier;
  access: ZObjectAccess;
  editorStore: SpecificationsAccessStore;
};

export const classifierAccessStore = makeAutoObservable({
  async init(classifierId: string) {
    try {
      this.setData({ status: "wait" });
      const [classifier, access] = await Promise.all([
        loadClassifier(classifierId),
        loadObjectAccess("classifier", classifierId),
      ]);
      const save = async (views: ZSpecAccess[]): Promise<ZSpecAccess[]> => {
        const res = await saveObjectAccess("classifier", classifierId, {
          views,
        });
        return res.views;
      };
      const editorStore = new SpecificationsAccessStore(access.views, save);
      const result = { classifier, access, editorStore };
      this.setData({ status: "ready", result });
    } catch (error) {
      this.setData({ status: "error", error });
    }
  },
  data: {} as RemoteData<ClassifierAccessData>,
  setData(newData: RemoteData<ClassifierAccessData>) {
    this.data = newData;
  },
  get crumbs() {
    const items: BreadcrumbItem[] = [
      { title: "Классификаторы", page: PageUrl.managementClassifiers },
    ];
    const { data } = this;
    if (data.status === "ready") {
      const { classifier } = data.result;
      items.push({
        title: classifier.name,
        page: PageUrl.managementClassifierCard,
        params: { id: classifier.id },
      });
    }
    items.push({ title: "Представление" });
    return items;
  },
});
